import script from "./CoinIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./CoinIcon.vue?vue&type=script&setup=true&lang=js"

import "./CoinIcon.vue?vue&type=style&index=0&id=28c9bf65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28c9bf65"]])

export default __exports__